<template>
    <Card class="AdminLatestRegistrations">
        <h2>Latest registrations</h2>

        <div class="item" v-for="company in companies" :key="company.id">
            <div class="main">
                <h4>{{ company.name }}</h4>
                <span>Registered {{ company.createdAt | formatDateDistance }}</span>
            </div>

            <!-- Add view company link here -->
            <a href="" @click.prevent="handleViewCompany(company)">View</a>
            <!-- <router-link to="" class="disabled">View</router-link> -->
        </div>
    </Card>
</template>

<script>
import Card from '@/components/Card';

export default {
    name: 'AdminLatestRegistrations',

    components: { Card },

    props: {
        companies: { type: Array, required: true },
    },

    methods: {
        handleViewCompany(company) {
            this.$store.dispatch('auth/setAdminCompany', company);
            this.$router.push('/company/dashboard');
        },
    },
};
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.AdminLatestRegistrations {
    padding: $grid-gutter-width;

    h2 {
        margin-bottom: 20px;
        font-weight: $font-weight-regular;
    }

    .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: $grid-gutter-width;

        span, a {
            font-size: 14px;
        }

        a {
            font-weight: $font-weight-bold;
        }
    }
}
</style>
